import React from 'react'

const SchedulingPlaceholder = props => (
  <div className='container-fluid bg-ui-4 pt-5 pt-md-0'>
    <div className='container px-0 px-md-1 py-0 py-md-4'>
      <div className='row mx mx-md-0  pt-5 pt-md-0  mt-5 mt-md-0'>
        <div className='col-12 px-0'>
          <div className='row mx-0 mx-md-auto'>
            <div className='userSidebar col-12 col-md-4 d-none d-md-block pr-3' >
              <div className='row mx-0'>
                <div className='col-12 px-0 bg-brand-5 radius border border-color-ui-3'>
                  <div className='row px-0 mx-0'>
                    <div className='col-12 px-0'>
                      <ul>
                        <li className='user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'>
                          <div className='row align-items-center h-100 mx-0'>
                            <div className='wishlist-button row col btn btn-flat bg-ui-3 py-1'>
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-6 mr-2 py-half radius bg-ui-3 py-1' />
                            </div>
                          </div>
                        </li>
                        <li className='user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'>
                          <div className='row align-items-center h-100 mx-0'>
                            <div className='wishlist-button row col btn btn-flat bg-ui-3 py-1'>
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-6 mr-2 py-half radius bg-ui-3 py-1' />
                            </div>
                          </div>
                        </li>
                        <li className='user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'>
                          <div className='row align-items-center h-100 mx-0'>
                            <div className='wishlist-button row col btn btn-flat bg-ui-3 py-1'>
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-6 mr-2 py-half radius bg-ui-3 py-1' />
                            </div>
                          </div>
                        </li>
                        <li className='user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'>
                          <div className='row align-items-center h-100 mx-0'>
                            <div className='wishlist-button row col btn btn-flat bg-ui-3 py-1'>
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-6 mr-2 py-half radius bg-ui-3 py-1' />
                            </div>
                          </div>
                        </li>
                        <li className='user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'>
                          <div className='row align-items-center h-100 mx-0'>
                            <div className='wishlist-button row col btn btn-flat bg-ui-3 py-1'>
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-6 mr-2 py-half radius bg-ui-3 py-1' />
                            </div>
                          </div>
                        </li>
                        <li className='user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'>
                          <div className='row align-items-center h-100 mx-0'>
                            <div className='wishlist-button row col btn btn-flat bg-ui-3 py-1'>
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-6 mr-2 py-half radius bg-ui-3 py-1' />
                            </div>
                          </div>
                        </li>
                        <li className='user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'>
                          <div className='row align-items-center h-100 mx-0'>
                            <div className='wishlist-button row col btn btn-flat bg-ui-3 py-1'>
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-6 mr-2 py-half radius bg-ui-3 py-1' />
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-8 px-0 px-md-0'>
              <div className='row mx-0'>
                <div className='col-12 border-color-ui-3 bg-white border radius'>
                  <div className='row px-3 py-3 border-bottom border-color-ui-3 '>
                    <div className='col px-0'>
                      <div className='txt-initial color-brand-1 mr-auto'>
                        <div className='col-4 mr-2 py-half radius bg-ui-3 py-1' />
                      </div>
                    </div>
                  </div>
                  <div className='pos-relative'>
                    <div className='row px-3 bg-ui-4 pt-2 pb-3 border-bottom border-color-ui-3 position-relative'>
                      <div className='col-12 px-0'>
                        <div className='col-12'>
                          <div className='row'>
                            <div className='Calendar-header col-12 row mx-0 mb-2'>
                              <div className='col-1 py-half radius bg-ui-3 py-1' />
                              <div className='col-4' />
                              <div className='col-2 px-5 py-half radius bg-ui-3 py-1' />
                              <div className='col-4' />
                              <div className='col-1 py-half radius bg-ui-3 py-1' />
                            </div>
                            <div className='Calendar-grid Calendar-week-day-names col-12 row mx-0 mt-1 mb-2'>
                              <div className='col-1 mr-2' />
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-2' />
                            </div>
                            <div className='Calendar-grid Calendar-week-day-names col-12 row mx-0 mt-1 mb-2'>
                              <div className='col-1 mr-2' />
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-1 mr-2 py-half radius bg-ui-3 py-1' />
                              <div className='col-2' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='calendarToggle txt-center pos-absolute bottom-0 mb-1'>
                      <label htmlFor='checkboxToggle'>
                        <div className='col-4 mr-2 py-half radius bg-ui-3 py-1' />
                      </label>
                    </div>
                  </div>
                  <div className='col-12 px-0'>
                    <div className='row justify-content-between'>
                      <div className='col-4 px-3 py-2'>
                        <div className='col-12 my-1 py-half radius bg-ui-3 py-1' />
                      </div>
                      <div className='col-4 px-3 py-2'>
                        <div className='col-12 py-half radius bg-ui-3 py-2' />
                      </div>
                    </div>
                    <div className='row'>
                      <div className='item-content col-12 txt-font-body txt-body-sm color-ui-2 radius-bottom pl-4 pr-3 pb-3'>
                        <div className='extract-item pos-relative row mt-3'>
                          <div className='col-auto row mx-0 pl-0'>
                            <div className='col-2 radius bg-ui-3 py-1 px-2' />
                          </div>
                          <div className='col-8'>
                            <p className='txt-subtitle row mx-0'><div className='col-4 mr-1 py-half radius bg-ui-3 mb-1' /></p>
                            <p className='mt-half row mx-0 txt-body-sm'>
                              <div className='col-5 mr-1 py-half radius bg-ui-3 mb-0' />
                            </p>
                          </div>
                          <div className='col-3 row mx-0 px-0'>
                            <p className='col-12 row mx-0 px-0'>
                              <strong className='txt-body-sm col-12 row mx-0 px-0 color-error'>
                                <div className='col-12 mr-1 py-half radius bg-ui-3 mb-0' />
                              </strong>
                            </p>
                          </div>
                        </div>
                        <div className='extract-item pos-relative row mt-3'>
                          <div className='col-auto row mx-0 pl-0'>
                            <div className='col-2 radius bg-ui-3 py-1 px-2' />
                          </div>
                          <div className='col-8'>
                            <p className='txt-subtitle row mx-0'><div className='col-4 mr-1 py-half radius bg-ui-3 mb-1' /></p>
                            <p className='mt-half row mx-0 txt-body-sm'>
                              <div className='col-5 mr-1 py-half radius bg-ui-3 mb-0' />
                            </p>
                          </div>
                          <div className='col-3 row mx-0 px-0'>
                            <p className='col-12 row mx-0 px-0'>
                              <strong className='txt-body-sm col-12 row mx-0 px-0 color-error'>
                                <div className='col-12 mr-1 py-half radius bg-ui-3 mb-0' />
                              </strong>
                            </p>
                          </div>
                        </div>
                        <div className='extract-item pos-relative row mt-3'>
                          <div className='col-auto row mx-0 pl-0'>
                            <div className='col-2 radius bg-ui-3 py-1 px-2' />
                          </div>
                          <div className='col-8'>
                            <p className='txt-subtitle row mx-0'><div className='col-4 mr-1 py-half radius bg-ui-3 mb-1' /></p>
                            <p className='mt-half row mx-0 txt-body-sm'>
                              <div className='col-5 mr-1 py-half radius bg-ui-3 mb-0' />
                            </p>
                          </div>
                          <div className='col-3 row mx-0 px-0'>
                            <p className='col-12 row mx-0 px-0'>
                              <strong className='txt-body-sm col-12 row mx-0 px-0 color-error'>
                                <div className='col-12 mr-1 py-half radius bg-ui-3 mb-0' />
                              </strong>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default SchedulingPlaceholder



// WEBPACK FOOTER //
// ./src/Participant/Scheduling/SchedulingPlaceholder.js